import { QueryFunctionContext } from "react-query"

import { endPoints } from '@/configs/endPoints'
import { API } from "@/utils/feature-flag-fetcher"

interface IFeatureFlag {
  erros: string[]
  sucesso: boolean
  conteudo: {
    idEmpregador: string
    featureFlag: string
  }
}

export async function getFeatureFlag(
  ctx: QueryFunctionContext<
    [
      string,
      {
        params: {
          employerId: string
          featureFlag: string
        }
      }
    ]
  >
): Promise<IFeatureFlag> {
  const [, { params }] = ctx.queryKey
  const rote = endPoints.featureFlag.replace('{id-empregador}', params.employerId)
  const response = await API.get<IFeatureFlag>(rote,
    {
      funcionalidade: params.featureFlag,
    }
  )

  return response;
}
